import React, {Component, PropTypes} from 'react'
import {Time} from './time';

export class TableListItem extends Component {

  static propTypes = { table: PropTypes.object.isRequired }

  render () {
    const {table} = this.props;
    return (
      <div className="table list-item">
        <div className="list-item__content">
          <div className="list-item__title">
            {table.title}
          </div>
          <div className="list-item__description">
            <Time time={table._msgTime || table.created} format='time-since'/>
          </div>
        </div>
        <div className="list-item__extra">
          <div className="icon-gear"/>
        </div>
      </div>
    );
  }
}
